import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import './file-download-item.js';
import css_248z from './file-download-updated.scss.js';

class FileDownloadUpdated extends s {
    constructor() {
        super(...arguments);
        this.items = [];
        this.rtl = false;
        this.isBlockName = false;
        this.groupTitle = 'Documents Downloads';
        this.groupId = crypto.randomUUID();
    }
    static renderFileDownloadItem(item) {
        return $ `<file-download-item-updated .image="${item.image}" .fileName="${item.fileName}" .ctaButton="${item.ctaButton}"></file-download-item-updated>`;
    }
    render() {
        const direction = this.rtl || isRTL() ? 'rtl' : 'ltr';
        const headingId = `${this.groupId}-title`;
        return $ `<section aria-labelledby="${headingId}" dir="${direction}"><h2 class="file-download-group__title ${this.isBlockName
            ? 'sr-only'
            : ''}" id="${headingId}">${o(this.groupTitle)}</h2><div class="file-download-group">${this.items.map(item => FileDownloadUpdated.renderFileDownloadItem(item))}</div></section>`;
    }
}
FileDownloadUpdated.styles = css_248z;
__decorate([
    e({ type: Array })
], FileDownloadUpdated.prototype, "items", void 0);
__decorate([
    e({ type: Boolean })
], FileDownloadUpdated.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], FileDownloadUpdated.prototype, "isBlockName", void 0);
__decorate([
    e({ type: String })
], FileDownloadUpdated.prototype, "groupTitle", void 0);
customElements.define('file-download-updated', FileDownloadUpdated);

export { FileDownloadUpdated };
